import { Directive, Injector, Input } from "@angular/core";
import { BfxFieldDirective } from "./bfx-field";

const BFX_FIELD_TEXT_DIRECTIVE = "bfx-field-text";

@Directive({
  selector: `[${BFX_FIELD_TEXT_DIRECTIVE}]`,
  host: { class: "bfx-field-container" },
  exportAs: "bfxFieldText",
  standalone: false,
})
export class BfxFieldTextDirective extends BfxFieldDirective {
  @Input("bfx-field-text")
  directiveInput: Record<string, any>;

  directiveInputName: string = BFX_FIELD_TEXT_DIRECTIVE;

  constructor(injector: Injector) {
    super(injector);
  }
}
